import { SimpleGrid, Stack } from '@chakra-ui/react'

import { Span } from 'components'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'
import CustomFormFileAnswer from 'components/tools/CustomForm/commonComponents/CustomFormSingleFileAnswer'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import { SEXES_OBJECT } from 'constants/variables'
import { cpfMask } from 'utils/masks'
import { formatDateToString } from 'utils/transforms/date'
import { capitalizeString } from 'utils/transforms/string'

export default function CustomFormCPFAnswer() {
  const { answer } = useCustomFormAnswer()

  const [
    cpf,
    name,
    mother_name,
    father_name,
    birth_certificate_date,
    sex,
    fileId,
    fileSlug,
    fileArchiveId,
    selfieId,
    selfieSlug,
    selfieArchiveId,
  ] = answer.answer || []

  return (
    <CustomFormEmptyAnswerFeedback>
      <Stack>
        <SimpleGrid columns={[1, 1, 2, 2, 2, 2]} gap={1} mt={2}>
          <Span label="CPF: " value={cpfMask(cpf)} />
          <Span label="Nome: " value={capitalizeString(name)} />
          <Span label="Nome da mãe: " value={capitalizeString(mother_name)} />
          <Span label="Nome do pai: " value={capitalizeString(father_name)} />
          <Span label="Data de nascimento: " value={formatDateToString(birth_certificate_date, false, '-')} />
          <Span label="Sexo: " value={SEXES_OBJECT[sex || 'UNKNOWM']} />
        </SimpleGrid>

        {fileId && fileSlug && fileArchiveId && (
          <CustomFormEmptyAnswerFeedback>
            <CustomFormFileAnswer fileId={fileId} fileSlug={fileSlug} archiveId={fileArchiveId} />
          </CustomFormEmptyAnswerFeedback>
        )}

        {selfieId && selfieSlug && selfieArchiveId && (
          <CustomFormEmptyAnswerFeedback>
            <CustomFormFileAnswer fileId={selfieId} fileSlug={selfieSlug} archiveId={selfieArchiveId} />
          </CustomFormEmptyAnswerFeedback>
        )}
      </Stack>
    </CustomFormEmptyAnswerFeedback>
  )
}
